import React from "react";

const SignUp = () => (
  <React.Fragment>
  </React.Fragment>
);

export default SignUp;
